import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface SectionHeadingProps {
  position: "right" | "left";
}
export default styled.h1<SectionHeadingProps>`
  width: max-content;
  margin: 0;
  padding: 25px 27px 15px 12px;
  border: none;
  border-bottom: 8px solid #a6be0a;
  line-height: 1;
  color: #232323;
  font-weight: 700;
  font-size: 26px;

  @media screen and (min-width: ${DESKTOP}px) {
    border: none;
    position: relative;
    font-size: 46px;
    margin-bottom: 8px;
    ${({ position }) =>
      position === "right" &&
      `
      left: 30px;
      padding: 20px 0 15px 0;
    `}

    ${({ position }) =>
      position === "left" &&
      `
      left: 114px;
      padding: 20px 0 15px 0;
    `}
  }
`;
